import { DataFilter } from '@siclop/kstone-vue'

export class ServiceTypeFilter extends DataFilter {
  code?: string
  label?: string
  activeOnly?: boolean

  constructor(data?: Partial<ServiceTypeFilter>) {
    super(data)
    if (data) {
      this.code = data.code
      this.label = data.label
      this.activeOnly = data.activeOnly
    }
  }
}
